import React, { useEffect, useState, useRef } from "react";
import PulseLoader from "react-spinners/PulseLoader";
import { useLiquidity } from "../../hooks/useLiquidity";
import { useToken } from "../../hooks/useToken";
import "../common/balance/balances.css";

const GetLpViewing = ({ pair, handlelpViewing }: any) => {
  const { createViewingKeyforLP } = useToken();
  const [isLoading, setIsLoading] = useState(false);
  // const isLoading = useRef<boolean>(false);

  useEffect(() => {
    // fetchBalance(false);
  }, []);

  const { getPoolUserAmount } = useLiquidity();

  const handleCreateViewingKey = async () => {
    setIsLoading(true);
    await createViewingKeyforLP(pair);
    const { lpBalance } = await getPoolUserAmount(pair);
    // temp(lpBalance);
    // setActiveCoinBalance(lpBalance);
    handlelpViewing();
    setIsLoading(false);
  };

  return (
    <>
      {isLoading ? (
        <PulseLoader
          color="#A69CAC"
          loading={true}
          // cssOverride={override}
          size={10}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      ) : (
        <div
          className="asset-common-button common-button"
          onClick={handleCreateViewingKey}
        >
          Get LPbal
        </div>
      )}
    </>
  );
};

export default GetLpViewing;
